export default __webpack_public_path__ + "static/media/divo.35f8d096.jpg";